import { TraitRegistryQuestion } from './TraitRegistryQuestion';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitRegistryBundle } from './TraitRegistryBundle';
import { TraitRegistryStage } from './TraitRegistryStage';
export class TraitRegistryActortype extends TraitRegistryCategory {
    label = 'by Actor';
    c_b = new TraitRegistryBundle(this);
    c_q = new TraitRegistryQuestion(this);
    c_s = new TraitRegistryStage(this);
}
